import { m } from '@/lib/paraglide/messages'
import { twJoin } from '@/lib/utils'

/** Chiều cao khung bản đồ — khung camera dùng đúng số này để hai tab cao bằng
 *  nhau, đổi qua lại không nhảy layout. */
export const AREA_VIEW_H = 380

export type AreaView = 'map' | 'camera'

/**
 * Nút chuyển "Bản đồ | Camera (n)" trong một vùng trồng. Dùng chung cho màn sửa
 * và màn chỉ xem để hai bên không lệch nhau.
 */
export function AreaViewToggle({
    view,
    onChange,
    cameraCount,
}: {
    view: AreaView
    onChange: (view: AreaView) => void
    cameraCount: number
}) {
    return (
        <div className="inline-flex rounded-md border bg-muted/50 p-0.5">
            <Tab active={view === 'map'} onClick={() => onChange('map')}>
                {m.grower_area_view_map()}
            </Tab>
            <Tab active={view === 'camera'} onClick={() => onChange('camera')}>
                {m.grower_area_view_camera({ count: cameraCount })}
            </Tab>
        </div>
    )
}

function Tab({
    active,
    onClick,
    children,
}: {
    active: boolean
    onClick: () => void
    children: React.ReactNode
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-pressed={active}
            className={twJoin(
                'rounded-[0.3rem] px-3 py-1.5 text-sm font-medium transition-colors',
                active
                    ? 'bg-card text-foreground shadow-sm'
                    : 'text-muted-foreground hover:text-foreground',
            )}
        >
            {children}
        </button>
    )
}
